import * as v from "valibot";

// request
export const RequestSchema = v.object({
  ClusterId: v.string(),
  MachineType: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const DataSchema = v.object({
  IsMachineTypeExist: v.boolean(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
